
import axios from 'axios'
import { Offer, RequestForProposalPayload } from 'src/core/models'

export async function getOffersAPI(): Promise<Offer[]> {
  const { data } = await axios.get('/api/v1/offers?page_size=99999')
  return data?.results
}

export async function expireOfferAPI(id: number): Promise<Offer[]> {
  const url = `/api/v1/offers/${id}/expire/`
  const { data } = await axios.put(url, { 'state': 'expired' })
  return data
}

export async function declineOfferAPI(id: number): Promise<any> {
  const url = `/api/v1/offers/${id}/decline/`
  const { data } = await axios.put(url, { 'state': 'declined' })
  return data
}

export async function acceptOfferAPI(id: number): Promise<any> {
  const url = `/api/v1/offers/${id}/accept/`
  const { data } = await axios.post(url, {})
  return data
}

export async function sendRequestForProposalAPI(payload: RequestForProposalPayload) {
  await axios.post('/api/v1/requests_for_propsals/', {
    ...payload,
    countries: payload.countries || [],
    standards: payload.standards || [],
    types: payload.types || [],
  })
}
